{
  "name": "control-station",
  "version": "0.18.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c localdev",
    "start:beacon": "ng serve -c beacon-development",
    "build": "ng build",
    "build:beacon": "ng build --configuration beacon",
    "watch": "ng build --watch --configuration development",
    "test": "cross-env NODE_OPTIONS=--no-experimental-webstorage ng test --watch=false",
    "lint": "ng lint",
    "e2e": "playwright test",
    "normalize-eol": "node scripts/normalize-eol.mjs",
    "check-eol": "node scripts/normalize-eol.mjs --check"
  },
  "private": true,
  "packageManager": "npm@11.8.0",
  "dependencies": {
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.1",
    "@angular/router": "^22.1.1",
    "@lucide/angular": "^1.31.0",
    "@ngrx/signals": "^21.1.0",
    "angular-auth-oidc-client": "^21.0.3",
    "mapbox-gl": "^3.28.1",
    "matrix-js-sdk": "^42.1.0",
    "mgrs": "^2.2.0",
    "range-slider-input": "^2.4.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.1",
    "@eslint/js": "^10.0.1",
    "@types/geojson": "^7946.0.16",
    "@types/node": "^26.2.0",
    "angular-eslint": "22.1.0",
    "cross-env": "^10.1.0",
    "eslint": "^10.6.0",
    "jsdom": "^30.0.1",
    "prettier": "^3.9.6",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.62.1",
    "vitest": "^4.1.10"
  },
  "allowScripts": {
    "@parcel/watcher@2.6.0": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "esbuild@0.28.1": true
  }
}
